import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-35071429")

_pushScopeId("data-v-35071429")
const _hoisted_1 = { class: "fridgereductioninfo-page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "fridgereductioninfo-page-topspacer" }, null, -1)
const _hoisted_3 = { class: "fridgereductioninfo-page-grapharea-scale" }
const _hoisted_4 = { class: "fridgereductioninfo-page-grapharea-scale-y" }
const _hoisted_5 = { class: "fridgereductioninfo-page-grapharea-scale-y-item" }
const _hoisted_6 = { class: "fridgereductioninfo-page-grapharea-scale-y-item-text" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "fridgereductioninfo-page-grapharea-scale-spacer" }, null, -1)
const _hoisted_8 = { class: "fridgereductioninfo-page-grapharea-scale-xitem-text" }
const _hoisted_9 = { class: "fridgereductioninfo-page-grapharea-scale-yaxistitle" }
const _hoisted_10 = { class: "fridgereductioninfo-page-grapharea-scale-yaxistitle-text" }
const _hoisted_11 = { class: "fridgereductioninfo-page-grapharea-scale-xaxistitle" }
const _hoisted_12 = { class: "fridgereductioninfo-page-grapharea-scale-xaxistitle-text" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "fridgereductioninfo-page-graphbottomspacer" }, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "fridgereductioninfo-page-reduction"
}
const _hoisted_15 = { class: "fridgereductioninfo-page-reduction-content-other" }
const _hoisted_16 = { class: "fridgereductioninfo-page-reduction-content-other-title" }
const _hoisted_17 = { class: "fridgereductioninfo-page-reduction-content-other-title-text" }
const _hoisted_18 = { class: "fridgereductioninfo-page-reduction-content-other-price" }
const _hoisted_19 = { class: "fridgereductioninfo-page-reduction-content-other-price-value" }
const _hoisted_20 = { class: "fridgereductioninfo-page-reduction-content-other-price-value-text" }
const _hoisted_21 = { class: "fridgereductioninfo-page-reduction-content-other-price-unit" }
const _hoisted_22 = { class: "fridgereductioninfo-page-reduction-content-other-price-unit-text" }
const _hoisted_23 = { class: "fridgereductioninfo-page-reduction-content-current" }
const _hoisted_24 = { class: "fridgereductioninfo-page-reduction-content-current-title" }
const _hoisted_25 = { class: "fridgereductioninfo-page-reduction-content-current-title-text" }
const _hoisted_26 = { class: "fridgereductioninfo-page-reduction-content-current-price" }
const _hoisted_27 = { class: "fridgereductioninfo-page-reduction-content-current-price-value" }
const _hoisted_28 = { class: "fridgereductioninfo-page-reduction-content-current-price-value-text" }
const _hoisted_29 = { class: "fridgereductioninfo-page-reduction-content-current-price-unit" }
const _hoisted_30 = { class: "fridgereductioninfo-page-reduction-content-current-price-unit-text" }
const _hoisted_31 = { class: "fridgereductioninfo-page-reduction-content-other" }
const _hoisted_32 = { class: "fridgereductioninfo-page-reduction-content-other-title" }
const _hoisted_33 = { class: "fridgereductioninfo-page-reduction-content-other-title-text" }
const _hoisted_34 = { class: "fridgereductioninfo-page-reduction-content-other-price" }
const _hoisted_35 = { class: "fridgereductioninfo-page-reduction-content-other-price-value" }
const _hoisted_36 = { class: "fridgereductioninfo-page-reduction-content-other-price-value-text" }
const _hoisted_37 = { class: "fridgereductioninfo-page-reduction-content-other-price-unit" }
const _hoisted_38 = { class: "fridgereductioninfo-page-reduction-content-other-price-unit-text" }
const _hoisted_39 = { class: "fridgereductioninfo-page-reduction-note" }
const _hoisted_40 = { class: "fridgereductioninfo-page-reduction-note-text" }
const _hoisted_41 = {
  key: 2,
  class: "fridgereductioninfo-page-footnote"
}
const _hoisted_42 = { class: "fridgereductioninfo-page-footnote-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.reductionInfo)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "fridgereductioninfo-page-grapharea",
          style: _ctx.styleGraphArea
        }, [
          _createVNode("canvas", {
            class: "fridgereductioninfo-page-grapharea-canvas",
            ref: "canvas",
            width: _ctx.canvasSize.width,
            height: _ctx.canvasSize.height
          }, null, 8, ["width", "height"]),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.yAxisScales, (scaleText) => {
                return (_openBlock(), _createBlock("div", { key: scaleText }, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("span", _hoisted_6, _toDisplayString(scaleText), 1)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _hoisted_7,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.xAxisScales, (xscaleText) => {
              return (_openBlock(), _createBlock("div", {
                class: "fridgereductioninfo-page-grapharea-scale-xitem",
                key: xscaleText
              }, [
                _createVNode("span", _hoisted_8, _toDisplayString(xscaleText), 1)
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createVNode("div", _hoisted_9, [
              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.yAxisTitle), 1)
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.xAxisTitle), 1)
            ])
          ])
        ], 4))
      : _createCommentVNode("", true),
    _hoisted_13,
    (_ctx.reductionInfo)
      ? (_openBlock(), _createBlock("div", _hoisted_14, [
          _createVNode("div", {
            class: "fridgereductioninfo-page-reduction-content",
            style: _ctx.styleGraphArea
          }, [
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("span", _hoisted_17, _toDisplayString(_ctx.previousMonthText), 1)
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("span", _hoisted_20, _toDisplayString(_ctx.previousMonthPriceText), 1)
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("span", _hoisted_22, _toDisplayString(_ctx.priceUnitText), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("span", _hoisted_25, _toDisplayString(_ctx.currentMonthText), 1)
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _createVNode("span", _hoisted_28, _toDisplayString(_ctx.currentMonthPriceText), 1)
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("span", _hoisted_30, _toDisplayString(_ctx.priceUnitText), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                _createVNode("span", _hoisted_33, _toDisplayString(_ctx.previousYearMonthText), 1)
              ]),
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("span", _hoisted_36, _toDisplayString(_ctx.previousYearMonthPriceText), 1)
                ]),
                _createVNode("div", _hoisted_37, [
                  _createVNode("span", _hoisted_38, _toDisplayString(_ctx.priceUnitText), 1)
                ])
              ])
            ])
          ], 4),
          _createVNode("div", _hoisted_39, [
            _createVNode("span", _hoisted_40, _toDisplayString(_ctx.reductionNoteText), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.reductionInfo)
      ? (_openBlock(), _createBlock("div", _hoisted_41, [
          _createVNode("span", _hoisted_42, _toDisplayString(_ctx.footNoteText), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})